<template>
  <div>
    <div>
      <!-- <b-row class="component-margin">
        <b-col sm="3">
            <b-input size="sm" v-model="nameFilter" placeholder="ASINコード、JANコード、商品名、FBA番号"/>
        </b-col>
        <b-col sm="5">
          <b-btn size="sm" @click="outputCsv(null)" variant="danger">ファイル出力</b-btn>
          <b-btn v-if="editable" size="sm" class="component-margin-left" @click="createKako(null)" variant="danger">新規登録</b-btn>
        </b-col>
      </b-row> -->
      <b-row class="component-margin-half">
        <b-col sm="12">
          <inbound-slc-analysis
            :slcAnalysisItems="slcAnalysisItems"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h4>ポイント明細</h4>
        </b-col>
      </b-row>
      <b-row class="component-margin">
        <b-col class="zoom-back-1" sm="2">
          <date-picker id="startDate" :value="startDate" @change="updateStartDate($event)"/>
        </b-col>
        <b-col class="zoom-back-1" sm="2">
          <date-picker id="endDate" :value="endDate" @change="updateEndDate($event)"/>
        </b-col>
        <b-col sm="3">
          <b-btn size="sm" @click="outputCsv(null)" variant="danger">ファイル出力</b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="filteredItems" :fields="fields"
                  :current-page="currentPage" :per-page="perPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          </b-table>
          <!-- <div md="6">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
          </div> -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import InboundSlcAnalysis from '@/components/inbound/InboundSlcAnalysis';
import DatePicker from '@/components/common/DatePicker';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    editable: {
      default: false,
    }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'refDate', label: '基準日', sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'account', label: 'アカウント', sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'accountName', label: 'アカウント名', sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'quantity', label: '入庫数', sortable: true, variant: 'warning', class: 'table-rw3' },
        { key: 'quantitySet', label: '入庫数(セット)', sortable: true, variant: 'warning', class: 'table-rw3' },
        { key: 'quantityTrouble', label: '管理品登録数', sortable: true, variant: 'warning', class: 'table-rw3' },
        { key: 'quantityShipment', label: '発送数', sortable: true, variant: 'success', class: 'table-rw3' },
        { key: 'point', label: '総合ポイント', sortable: true, variant: 'danger', class: 'table-rw3' },
        { key: 'sellerCount', label: 'セラー数', sortable: true, variant: 'primary', class: 'table-rw3' },
      ],
      slcAnalysisItems: [],
      // currentPage: 1,
      // perPage: 100,
      // totalRows: 0,
      sortBy: 'refDate',
      sortDesc: true,
      sortDirection: 'asc',
      startDate: '',
      endDate: ''
    };
  },
  created() {
    var dtEnd = new Date();
    var dtStart = new Date();
    dtStart.setDate(dtStart.getDate()-30);

    var y = dtStart.getFullYear();
    var m = ('00' + (dtStart.getMonth()+1)).slice(-2);
    var d = ('00' + dtStart.getDate()).slice(-2);
    if(this.startDate === '') {
      this.startDate = y + m + d;
    }

    var y = dtEnd.getFullYear();
    var m = ('00' + (dtEnd.getMonth()+1)).slice(-2);
    var d = ('00' + dtEnd.getDate()).slice(-2);
    if(this.endDate === '') {
      this.endDate = y + m + d;
    }

    api.getAnalysisSlcInbound((data) => {
      this.slcAnalysisItems = data.slcAnalysisInfos;
      this.items = data.slcAnalysisDetailInfos;
    });
  },
  computed: {
    filteredItems() {
      // SLC担当かつ初回のみ登録される。
      let filteredItems = this.items.filter(item => {
          return (item.refDate >= this.startDate && item.refDate <= this.endDate);
        });
      return filteredItems;
    },
  },
  methods: {
    updateStartDate($event) {
      this.startDate = $event;
      // this.callApi();
    },
    updateEndDate($event) {
      this.endDate = $event;
      // this.callApi();
    },
    outputCsv() {
      let csv = '\ufeff' + '基準日,アカウント,アカウント名,入庫数,入庫数(セット),管理品登録数,発送数,ポイント,セラー数\n';
      let ids = [ 'refDate', 'account', 'accountName', 'quantity', 'quantitySet', 'quantityTrouble', 'quantityShipment', 'point', 'sellerCount' ];
      let fileName = '';
      for (const item of this.filteredItems) {
        csv = csv + '"';
        for (const id of ids) {
          if(item[id] == null || item[id] === ''){
            csv += '","';
          } else{
            if(isNaN(item[id])){
              csv += item[id].replace(/"/g, '') + '","';
            } else{
              csv += item[id] + '","';
            }
            // csv += item[id] + '","';
          }
        }
        csv = csv.substring(0, csv.length - 2);
        csv += '\n';
      }
      fileName = 'point.csv';
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};

Vue.component('inbound-slc-analysis', InboundSlcAnalysis);
Vue.component('date-picker', DatePicker);

</script>

<style>
.component-margin-half {
  margin-bottom: .5rem;
}
.component-margin {
  margin-bottom: 1rem;
}
.zoom-back-0{
  z-index: 0;
}
.zoom-back-1{
  z-index: 1;
}
@media (min-width: 768px) {
  .table-right  { text-align:right!important; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right!important; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left!important; }
}
</style>
